import React from 'react';
import StatGraphs from './StateGraph';
import {Button} from 'antd';
/*import {green, red} from '@ant-design/colors';*/
import {
  StyledAnaStateCard,
  StyledAnaStateContent,
  StyledAnaStateGraphs,
  StyledAnaStateHeader,
  StyledAnaStateItem,
  StyledAnaStateRow,
} from './index.styled';
import {rgba} from 'polished';

type RevenueCardsType = {
  title: string;
  value: string;
  icon?: JSX.Element;
  color: string;
  highlightValue?: boolean;
  graphData?: {x: string; y: number}[];
};

const StateCard: React.FC<RevenueCardsType> = ({
  title,
  value,
  icon = null,
  color,
  highlightValue = false,
  graphData = [],
}) => {
  return (
    <StyledAnaStateCard>
      <StyledAnaStateContent>
        <StyledAnaStateRow>
          {icon == null ? (
            <StyledAnaStateItem style={{textAlign: 'left'}}>
              <p>{title}</p>
            </StyledAnaStateItem>
          ) : (
            <div
              style={{
                color,
                padding: 8,
                backgroundColor: rgba(color, 0.1),
                borderRadius: '50%',
              }}
            >
              {icon}
            </div>
          )}
          <StyledAnaStateItem>
            <StyledAnaStateHeader className='text-truncate'>
              {highlightValue ? <h2>{value}</h2> : <h3>{value}</h3>}
            </StyledAnaStateHeader>
            {icon != null && <p>{title}</p>}
          </StyledAnaStateItem>
        </StyledAnaStateRow>
        <StyledAnaStateGraphs>
          <StatGraphs data={graphData} strokeColor={color} />
        </StyledAnaStateGraphs>
      </StyledAnaStateContent>
    </StyledAnaStateCard>
  );
};

export default StateCard;
